import CardLoading from '@op/components/CardLoading';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { gameInfoType } from '@op/types/common';
import React, { useMemo, useState } from 'react';
import './index.scss';
import GameComparisonTable from '../components/GameComparisonTable';
import { ServerTimeType } from '@op/components/FilterCommon/types';
import GameComparisonChart from '../components/GameComparisonChart';
import { COMPARE_COLORS } from '../constant';
import { useMetricsChannel } from '@op/hooks/useMetricsChannel';
import HotContent from '../../ChannelShareRanking/HotContent';

export default function DifferentStartDate({
  gameInfo,
}: {
  gameInfo: gameInfoType;
}) {
  const { loading, filter, changeFilter, scrollBody, filterOptions } =
    useFilterDataHook({
      pageName: 'Competitor_Different_Start_Date',
      gameInfo,
    });

  const [metrics, setMetrics] = useState<Array<string>>([]);
  const [gameData, setGameData] = useState<{ [key: string]: any }>({});
  const [dateType, setDateType] = useState<ServerTimeType>('daily');
  const [color, setColor] = useState<{ [key: string]: string }>({});
  const MergeChannelIconElement = useMetricsChannel({ gameInfo });

  const [selectedGameInfo, setSelectedGameInfo] = useState(null);
  const [showHotContent, setShowHotContent] = useState(false);
  const [filterValue, setFilterValue] = useState({});

  function changeGameInfo(gameInfo: any) {
    setSelectedGameInfo(gameInfo);
    setShowHotContent(true);
  }

  function onClear() {
    setShowHotContent(false);
    setSelectedGameInfo(null);
  }

  const hotContentFilter = useMemo(() => {
    const { compare_games, metrics, ...restFilter } = filter || {};
    return {
      ...restFilter,
      ...filterValue
    };
  }, [filter, filterValue]);

  return (
    <div className="dbo-different-start-date">
      <FilterFixed
        filter={filterOptions}
        operateShowOptions={[]}
        hasLaunchTime={false}
        isTile
        finallyDealwithDefaultValue={(value: any) => {
          const { compare_games, ...info } = value;
          return info;
        }}
        confirm={(value) => {
          const { metrics, gameData, compare_games, dateType, ...otherInfo } =
            value;
          setMetrics(metrics);
          setGameData(gameData);
          setDateType(dateType);
          setColor(
            compare_games.reduce((acc, val, index) => {
              const { edition_unified_id, start_time, end_time } = val;
              const color = COMPARE_COLORS[index];
              const id = `${edition_unified_id}_${start_time}_${end_time}_${index}`;
              acc[id] = color;
              return acc;
            }, {}),
          );
          onClear();
          changeFilter({ metrics, compare_games, ...otherInfo, ...gameInfo });
        }}
        defaultConfig={{
          regionAndLanguage: {
            toggleLanguage: false,
          },
        }}
      ></FilterFixed>

      <CardLoading loading={loading}>
        <div className='dbo-different-start-date-row'>
          <GameComparisonTable
            filter={filter}
            metrics={metrics}
            gameData={gameData}
            dateType={dateType}
            color={color}
            gameInfo={gameInfo}
            MergeChannelIconElement={MergeChannelIconElement}
            changeGameInfo={changeGameInfo}
            selectedGameInfo={selectedGameInfo}
            handleFilterValue={setFilterValue}
          />
          <div className={`dbo-different-start-date-row--right ${showHotContent ? '--show' : ''}`} >
            <HotContent
              onClear={onClear}
              selectedGameInfo={selectedGameInfo}
              filter={hotContentFilter}
            ></HotContent>
          </div>
        </div>

        <GameComparisonChart
          filter={filter}
          metrics={metrics}
          gameData={gameData}
          dateType={dateType}
          color={color}
          gameInfo={gameInfo}
        />
      </CardLoading>
    </div>
  );
}
